import script from "./NewsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsPage.vue?vue&type=script&setup=true&lang=ts"

import "./NewsPage.vue?vue&type=style&index=0&id=8fae7c48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fae7c48"]])

export default __exports__